module.exports = __webpack_public_path__ + "static/media/mading.4892f709.jpeg";